import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { Check, View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { VehicleAvatar } from '../../../../components/VehicleAvatar';
import { selectWorks } from '../../../Api/selectors';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { performAction, refreshBoards } from '../../actions';
import {
  REQUEST_KANBAN_BOARD_PERFORM_ACTION,
  TASK_STATUS_ACTIVE,
  TASK_STATUS_INACTIVE,
  TASK_STATUS_PLAN,
} from '../../constants';
import { PerformActionButton } from '../PerformActionButton';
import { BaseCellComp } from '../BaseCellComp';
import { CompanyLabelById } from '../../../Companies/components/CompanyLabelById';
import { CellButton, CellButtons } from '../CellButton';
import { Well } from '../../../../components/Well';
import { VBox } from '../../../../components/Box';
import { Checkbox } from '../../../../components/Checkbox';
import { VehiclePropertyEditableInput } from '../../../Vehicles/components/VehiclePropertyEditableInput';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { selectVehicle } from '../../../Vehicles/selectors';
import { List, Row, Cell } from '../../../../components/List';
import { Label, getLabelColor } from '../../../Vehicles/components/VehicleCounterLabel';

import { Cell as ActionCell } from '../Cell';
import { formatCurrency } from '../../../../utils/string';
import { updateInvoiceStatus } from '../../../Invoices/actions';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import styles from './ADM_NL_IDW.module.css';

//change this for values of counters
const ranges = {
  MediumSeaGreen: [1, 3],
  DarkOrange: [4, 6],
  Crimson: [7, Infinity],
};

const Container = styled.div`
  .pane {
    padding: 24px 12px;

    .fields {
      margin-top: 24px;
    }

    h3 {
      margin-bottom: 12px;
    }

    h4 {
      margin-top: 24px;
      font-size: 20px;
    }
  }
`;

const STATE = {
  approve: false,
};

/* eslint-disable react/prefer-stateless-function */
class Transport_incoming_released_to_planComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  get vehicle() {
    return this.props.vehicle || this.props.cell.vehicle;
  }

  render01(name) {
    return (
      <Checkbox
        key={name}
        checked={this.state[name] == TASK_STATUS_ACTIVE}
        onChange={() => {
          this.setState({ [name]: this.state[name] != TASK_STATUS_ACTIVE ? TASK_STATUS_ACTIVE : TASK_STATUS_INACTIVE });
        }}
      >
        {this.lbl(`vehicle.property.${name}`)}
      </Checkbox>
    );
  }

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.props.action.label}>
        {this.renderModalBody()}
      </ModalComponent>
    );
  }

  renderModalBody() {
    if (this.state.loading) return <Loader />;
    return (
      <WithVehicle vehicle_id={this.vehicle.id} loader>
        <VehicleHeader vehicle={this.vehicle} />
        <div className="pane"></div>
        {this.vehicle ? <VBox center></VBox> : null}

        <div className="d-flex gap-2 mt-2">
          <PerformActionButton
            className={styles.confirmButton}
            action={this.props.action}
            target={this.vehicle}
            onChange={this.reset.bind(this)}
          />
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </WithVehicle>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <ActionCell className={styles.cell}>
        <Container>
          <VehicleHeader vehicle={vehicle} />
          <Label count={this.vehicle?.transportinkomend} ranges={ranges}>
            {this.vehicle?.transportinkomend || '0'}
          </Label>
          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <div className={styles.cellButtonContainer}>
                <CellButton onClick={this.setStateFn({ approve: !this.state.approve })}>
                  <View />
                </CellButton>
              </div>
            )}
          </CellButtons>
          {this.renderApprove()}
        </Container>
      </ActionCell>
    );
  }
}

Transport_incoming_released_to_planComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`]),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    invoicePaid(invoiceId, callback) {
      dispatch(updateInvoiceStatus(invoiceId, 2, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const Transport_incoming_released_to_plan = compose(withConnect, withRouter)(Transport_incoming_released_to_planComp);
